import { AxiosError } from 'axios';
import { BaseClient } from '../client';
import { TAnuncioTabela } from './offer.types';
import { offersByDealerMock } from './offer.mocks';

interface getOffersByDealerIdProps {
	id: number;
}

export const getOffersByDealerId = async ({ id }: getOffersByDealerIdProps) => {
	// if (process.env.NODE_ENV === 'development') {
	// 	return offersByDealerMock as TAnuncioTabela[];
	// }

	try {
		const response = await BaseClient.get<TAnuncioTabela[]>(
			`/Anuncios/GetAnuncioCadastradosPorConcessionaria/${id}`
		)
			.then((response) => response.data)
			.catch((error: AxiosError) => {
				if (error.response?.status === 404) {
					return [];
				}

				throw error;
			});

		return response;
	} catch (error) {
		console.error(error);
	}
};
